import { apiClientGeral } from '@/plugins/axios'

export default {
  getPjsipTransport() {
    return apiClientGeral().get('/pjsiptransport')
  },

  postPjsipTransport(form) {
    return apiClientGeral().post('/pjsiptransport', form)
  },

  putPjsipTransport(form) {
    return apiClientGeral().put('/pjsiptransport', form)
  },
}
